import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import StepRoutes from "../../Routes/steps_routes";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import LoadingPage from "../../Components/layouts/loading";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentPage,
  setReduxFilters,
} from "../../redux/Filtered leads/newenquiriesReducer";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcCallback } from "react-icons/fc";
import EnquiryTable from "./enquiry_table";
import { GrAdd } from "react-icons/gr";

const NewEnquiryData = () => {
  const user = useSelector((store) => store?.login?.user);

  const store = useSelector((store) => store?.newenquiryReducer);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState(store.filters);
  const [page, setCurrPage] = useState(store.currentPage);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [count, setCount] = useState();
  const [overall, setOverall] = useState();
  const [leadOwner, setLeadOwner] = useState([]);

  const userRoles = [
    process.env.REACT_APP_ROLE_ADMIN_S,
    process.env.REACT_APP_ROLE_ADMIN,
  ];

  const isUserRoll = userRoles.includes(user?.Role);

  const allowedRoles = [
    process.env.REACT_APP_ROLE_SALLE,
    process.env.REACT_APP_ROLE_SALLE_ADMIN,
    process.env.REACT_APP_ROLE_HR,
    process.env.REACT_APP_ROLE_SALESAGENCY,
    process.env.REACT_APP_ROLE_SALES_MANAGER,
    process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
  ];

  const canShowGetEnquiryButton = allowedRoles.includes(user?.Role);

  useEffect(() => {
    setLoading(true);

    performRequest(
      "GET",
      getFilteredURL(
        `/enquiryWebhook/getjustDiel_myOperatorEnquiry`,
        store.currentPage,
        {
          ...store.filters,
          role: user?.Role,
          userId: user?.UserId,
        }
      )
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.enquiriesData);
          setTotalPages(Math.ceil(res.data?.enquiriesCount / 50));
          setCount(res.data?.enquiriesCount);
          setOverall(res.data?.totalCountAssign);
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, store.currentPage]);

  useEffect(() => {
    setCurrPage(store.currentPage);
    setShowPage(Math.floor((store.currentPage - 1) / 5) * 5 + 1);
  }, [store.currentPage]);
  const setPage = (p) => {
    dispatch(setCurrentPage(p));
  };

  useEffect(() => {
    performRequest("GET", "/leads/getSalesEmployeeList/")
      .then((res) => {
        setLeadOwner(res.data);
      })
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const handelGetEnquiry = async () => {
    try {
      if (!user?.UserId) {
        Toast("error", "User Id not found");
        return;
      }

      setLoading(true);

      const res = await performRequest(
        "PATCH",
        `/enquiryWebhook/assignJdMyOpEnquiry/${user?.UserId}`
      );

      if (res.status === 200) {
        Toast("success", "Enquiry assigned successfully");
        setRefresh(!refresh);
      }
    } catch (error) {
      CustomErrorResponse(error);
    } finally {
      setLoading(false);
    }
  };

  const handelApplyFilter = () => {
    let updatedFilters = { ...filters };

    // Check if any filter other than call status is selected
    const hasOtherFilters =
      updatedFilters.startdate ||
      updatedFilters.enddate ||
      updatedFilters.origin ||
      updatedFilters.employeeName ||
      updatedFilters.leadowner;

    if (!updatedFilters.number) {
      if (hasOtherFilters && !updatedFilters.attended) {
        updatedFilters.attended = "isAttended";
      }
    } else {
      updatedFilters.attended = "";
    }

    setFilters(updatedFilters);
    dispatch(setReduxFilters(updatedFilters));
    dispatch(setCurrentPage(1));
    setRefresh(!refresh);
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <h2 className="page-title mb-1">
                    <FcCallback className="fs-2  me-1" />
                    Enquiry
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
                <div className="col-md-4">
                  <div className="btn-list justify-content-end">
                    {canShowGetEnquiryButton && (
                      <button
                        className="btn btn-primary "
                        onClick={handelGetEnquiry}
                      >
                        <GrAdd className="me-2 fs-2" />
                        Get Enquiry
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-1">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        startdate: e.target.value,
                                      })
                                    );
                                  }}
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        enddate: e.target.value,
                                      })
                                    );
                                  }}
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search Mobile:"
                                  value={filters.number}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      number: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        number: e.target.value,
                                      })
                                    );
                                  }}
                                  placeholder="search here..."
                                />
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Call Status"
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      attended: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        attended: e.target.value,
                                      })
                                    );
                                  }}
                                  value={filters.attended}
                                >
                                  <option value="">select all</option>
                                  <option value="isAttended">Attended</option>
                                  <option value="isNotAttended">
                                    Not Attended
                                  </option>
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Origin"
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      origin: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        origin: e.target.value,
                                      })
                                    );
                                  }}
                                  value={filters.origin}
                                >
                                  <option value="">Select all</option>
                                  <option value="MyOperator">
                                    My Operator
                                  </option>
                                  <option value="just_dial_enquiry">
                                    Just Dial
                                  </option>
                                </DynamicFilterSelect>
                              </div>

                              {isUserRoll && (
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Employee Name"
                                    value={filters.employeeName}
                                    onChange={(e) => {
                                      setFilters({
                                        ...filters,
                                        employeeName: e.target.value,
                                      });

                                      dispatch(
                                        setReduxFilters({
                                          ...filters,
                                          employeeName: e.target.value,
                                        })
                                      );
                                    }}
                                  >
                                    <option value="">Select Employee</option>

                                    {leadOwner?.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.userName}
                                      </option>
                                    ))}
                                  </DynamicFilterSelect>
                                </div>
                              )}

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={handelApplyFilter}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        dispatch(
                                          setReduxFilters({
                                            startdate: "",
                                            enddate: "",
                                            number: "",
                                            callType: "",
                                            attended: "",
                                            origin: "",
                                            employeeName: "",
                                          })
                                        );
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          number: "",
                                          callType: "",
                                          attended: "",
                                          origin: "",
                                          employeeName: "",
                                        });

                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  );
                                }}
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  );
                                }}
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Search Mobile:"
                                value={filters.number}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    number: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      number: e.target.value,
                                    })
                                  );
                                }}
                                placeholder="search here..."
                              />
                            </div>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Call Status"
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    attended: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      attended: e.target.value,
                                    })
                                  );
                                }}
                                value={filters.attended}
                              >
                                <option value="">select all</option>
                                <option value="isAttended">Attended</option>
                                <option value="isNotAttended">
                                  Not Attended
                                </option>
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Origin"
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    origin: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      origin: e.target.value,
                                    })
                                  );
                                }}
                                value={filters.origin}
                              >
                                <option value="">Select all</option>
                                <option value="MyOperator">My Operator</option>
                                <option value="just_dial_enquiry">
                                  Just Dial
                                </option>
                              </DynamicFilterSelect>
                            </div>

                            {isUserRoll && (
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Employee Name"
                                  value={filters.employeeName}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      employeeName: e.target.value,
                                    });

                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        employeeName: e.target.value,
                                      })
                                    );
                                  }}
                                >
                                  <option value="">Select Employee</option>

                                  {leadOwner?.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.userName}
                                    </option>
                                  ))}
                                </DynamicFilterSelect>
                              </div>
                            )}

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={handelApplyFilter}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      dispatch(
                                        setReduxFilters({
                                          startdate: "",
                                          enddate: "",
                                          number: "",
                                          callType: "",
                                          attended: "",
                                          origin: "",
                                        })
                                      );
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        number: "",
                                        callType: "",
                                        attended: "",
                                        origin: "",
                                      });

                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card mt-2 p-2 text-center">
                    <p className="fs-3">
                      JustDial + Operator Count : <b>{count}</b>
                    </p>
                    <p className="fs-3">
                      Overall Attempt Enquiry Count : <b>{overall}</b>
                    </p>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-1">
                  <div className="card">
                    {data && <EnquiryTable data={data} />}
                    {data.length > 0 && (
                      <Pagination
                        page={page}
                        setPage={setPage}
                        totalPages={totalPages}
                        pageDatalength={data?.length}
                        showPage={showPage}
                        setShowPage={setShowPage}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default NewEnquiryData;
